import { HttpClientJsonpModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { GraphQLModule } from '@hdms/shared/data-access';
import { PreloaderModule } from '@hdms/shared/ui-core';
import {
  EnvironmentModule,
  HttpInterceptorsModule,
  PreloaderControlModule,
  RouterBreadcrumbModule
} from '@hdms/shared/util-core';

import { environment } from '../environments/environment';

import { AppTranslationModule } from './app-translation.module';
import { SSR_APP_ID } from './constants';
import { AppRoutingModule } from './routing/app-routing.module';

export const APP_IMPORTS = [
  AppRoutingModule,
  AppTranslationModule,
  BrowserAnimationsModule,
  BrowserModule.withServerTransition({ appId: SSR_APP_ID }),
  EnvironmentModule.forRoot(environment),
  GraphQLModule,
  HttpClientJsonpModule,
  HttpInterceptorsModule,
  PreloaderModule,
  PreloaderControlModule.forRoot(),
  RouterBreadcrumbModule
];
